import React from 'react';
import PropTypes from 'prop-types';

const SIZE_MAP = {
  xs: 'h-[14px] w-[14px]',
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export default function Spinner({
  size = 'md',
  color = 'text-primary',
  variant = 'ring', // 'ring' | 'dots'
}) {
  const sz = SIZE_MAP[size] || SIZE_MAP.md;

  if (variant === 'dots') {
    // 3 pulsing dots
    return (
      <div className={`flex items-center space-x-1`}>
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className={`
              ${color} bg-current
              block
              rounded-full
              ${size === 'sm' ? 'h-1.5 w-1.5' : size === 'lg' ? 'h-2 w-2' : 'h-2 w-2'}
              animate-bounce-slow
            `}
            style={{ animationDelay: `${i * 0.2}s` }}
          />
        ))}
      </div>
    );
  }

  // default: a ring spinner
  return (
    <div
      className={`
        ${sz}
        inline-block
        animate-spin-slow
        rounded-full
        border-2
        border-current
        border-t-transparent
        flex items-center justify-center
        ${color}
      `}
      role="status"
      aria-label="loading"
    />
  );
}

Spinner.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  color: PropTypes.string,      // any text-color utility
  variant: PropTypes.oneOf(['ring','dots']),
};
